"use client";

import { devSectionAttr } from "@/lib/dev/section-attr";
import { useCopyLang } from "@/components/layout/use-site-ui-copy";
import { getGrowthFeatureDefaults } from "./growth-features/growth-feature-defaults-copy";
import { useCcSectionReveal } from "@/lib/use-cc-section-reveal";
import {
  GrowthFeatureAdPerformance,
  GrowthFeatureAiContent,
  GrowthFeatureCampaignAutomation,
  GrowthFeatureIntro,
  type GrowthFeatureIntroCopy,
  GrowthFeatureSeoAudits,
} from "@/components/home/growth-features";
import type { GrowthFeatureAdPerformanceCardCopy } from "@/components/home/growth-features/growth-feature-ad-performance-copy";
import type { GrowthFeatureAiContentCardCopy } from "@/components/home/growth-features/growth-feature-ai-content-copy";
import type { GrowthFeatureCampaignCardCopy } from "@/components/home/growth-features/growth-feature-campaign-copy";
import type { GrowthFeatureSeoAuditsCardCopy } from "@/components/home/growth-features/growth-feature-seo-audits-copy";

type CcGrowthFeaturesProps = {
  intro?: GrowthFeatureIntroCopy;
  seoAuditsCard?: GrowthFeatureSeoAuditsCardCopy;
  aiContentCard?: GrowthFeatureAiContentCardCopy;
  campaignCard?: GrowthFeatureCampaignCardCopy;
  adPerformanceCard?: GrowthFeatureAdPerformanceCardCopy;
};

export function CcGrowthFeatures({
  intro,
  seoAuditsCard,
  aiContentCard,
  campaignCard,
  adPerformanceCard,
}: CcGrowthFeaturesProps = {}) {
  const defaults = getGrowthFeatureDefaults(useCopyLang());
  const { ref, withRevealClassName } = useCcSectionReveal({ staggerChildren: true });

  return (
    <section
      ref={ref}
      className={withRevealClassName("cc-section cc-growth-features")}
      id="growth-features"
      data-cc-nav="light"
      {...devSectionAttr("growth-features")}
    >
      <div className="cc-container cc-growth-features__container">
        <GrowthFeatureIntro copy={intro ?? defaults.intro} />

        <div className="cc-growth-features__grid">
          <GrowthFeatureSeoAudits copy={seoAuditsCard ?? defaults.seoAudits} />
          <GrowthFeatureAiContent copy={aiContentCard ?? defaults.aiContent} />
          <GrowthFeatureCampaignAutomation copy={campaignCard ?? defaults.campaign} />
          <GrowthFeatureAdPerformance copy={adPerformanceCard ?? defaults.adPerformance} />
        </div>
      </div>
    </section>
  );
}
